var cov_1puk3rfwwd = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tabs/styles/index.js",
      hash = "9253ae3efec7c14efa2a9d2fc645a9da34132fc3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tabs/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var tabsLess = {};
import genaration from '../../utils/classname';
export var tabsClass = (cov_1puk3rfwwd.s[0]++, genaration(tabsLess, 'tabs'));